export default function initTextExpand() {
    const $textExpand = document.querySelectorAll<HTMLElement>('.block-text-expand');
    $textExpand.forEach($container => {
        new TextExpand($container);
    });
}

class TextExpand {
    $el: HTMLElement;
    $dropdownsLists: NodeListOf<HTMLElement>;

    constructor($el: HTMLElement) {
        this.$el = $el;
        this.$dropdownsLists = this.$el.querySelectorAll('.dropdowns-list');

        this.init();
    }

    init() {
        this.$dropdownsLists.forEach($list => {
            const $dropdowns = $list.querySelectorAll<HTMLDetailsElement>('.dropdown');
            
            $dropdowns.forEach($dropdown => {
                $dropdown.addEventListener('toggle', () => {
                    if ($dropdown.open) {
                        // Fermer tous les autres dropdowns de la même liste
                        $dropdowns.forEach($otherDropdown => {
                            if ($otherDropdown !== $dropdown && $otherDropdown.open) {
                                $otherDropdown.open = false;
                            }
                        });
                    }
                });
            });
        });
    }
}
